module.exports = __webpack_public_path__ + "img/image12.11ae426.webp";